module.exports = __webpack_public_path__ + "img/local_hotel.395b97b2.svg";